import React from 'react';
import {
    AppBar,
    Box,
    Button,
    Card,
    CardContent,
    Chip,
    IconButton,
    Paper,
    Tooltip,
    Typography,
    TablePagination,
} from '@material-ui/core';
import { Add as AddIcon, Edit as EditIcon, Delete as DeleteIcon } from '@material-ui/icons';

const CouponsPageMobile = ({
    storeId,
    coupons,
    loading,
    page,
    rowsPerPage,
    totalRows,
    onChangePage,
    onChangeRowsPerPage,
    onCreate,
    onEdit,
    onDelete,
    hasAtLeastOneUse,
    formatMoneyWithCode,
}) => {
    if (!storeId) {
        return (
            <Box p={2}>
                <Typography variant="h6">Cupones</Typography>
                <Typography variant="body2" color="textSecondary" style={{ marginTop: 8 }}>
                    Selecciona una tienda para ver y administrar cupones.
                </Typography>
            </Box>
        );
    }

    return (
        <Box>
            <AppBar
                position="static"
                elevation={0}
                style={{
                    background: '#fff',
                    color: '#1e1e1e',
                    borderBottom: '1px solid #ECECF2',
                    zIndex: 0,
                }}
            >
                <Box p={2} display="flex" justifyContent="space-between" alignItems="center">
                    <Box>
                        <Typography variant="h6">Cupones</Typography>
                        <Typography variant="body2" color="textSecondary">
                            Crea y administra cupones de descuento.
                        </Typography>
                    </Box>
                    <Button
                        color="primary"
                        variant="contained"
                        size="small"
                        startIcon={<AddIcon />}
                        onClick={onCreate}
                    >
                        Crear
                    </Button>
                </Box>
            </AppBar>

            <Box p={2} pb={1}>
                {loading && (
                    <Paper style={{ padding: 16, textAlign: 'center' }}>
                        <Typography variant="body2">Cargando cupones...</Typography>
                    </Paper>
                )}

                {!loading && coupons.length === 0 && (
                    <Paper style={{ padding: 16, textAlign: 'center' }}>
                        <Typography variant="body2">No hay cupones creados todavía.</Typography>
                    </Paper>
                )}

                {!loading &&
                    coupons.map((coupon) => {
                        const uses = coupon.current_uses || 0;
                        const maxUsesLabel = coupon.max_uses ? ` / ${coupon.max_uses}` : ' / ilimitado';
                        const validityFrom = coupon.valid_from
                            ? new Date(coupon.valid_from).toLocaleDateString()
                            : 'Desde ahora';
                        const validityTo = coupon.valid_until
                            ? new Date(coupon.valid_until).toLocaleDateString()
                            : 'Sin vencimiento';

                        return (
                            <Card key={coupon.id} style={{ marginBottom: 12, borderRadius: 10 }}>
                                <CardContent>
                                    <Box display="flex" justifyContent="space-between" alignItems="flex-start">
                                        <Box>
                                            <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
                                                {coupon.code}
                                            </Typography>
                                            <Typography variant="body2" color="textSecondary">
                                                {coupon.discount_type === 'percentage'
                                                    ? 'Porcentaje'
                                                    : 'Monto fijo'}
                                            </Typography>
                                        </Box>
                                        <Chip
                                            size="small"
                                            label={coupon.active ? 'Activo' : 'Inactivo'}
                                            style={{
                                                backgroundColor: coupon.active ? '#E7F8EE' : '#F1F1F1',
                                                color: coupon.active ? '#0f7a3a' : '#666',
                                            }}
                                        />
                                    </Box>

                                    <Box mt={1}>
                                        <Typography variant="body2">
                                            <strong>Descuento:</strong>{' '}
                                            {coupon.discount_type === 'percentage'
                                                ? `${coupon.discount_value}%`
                                                : formatMoneyWithCode(coupon.discount_value)}
                                        </Typography>
                                        <Typography variant="body2">
                                            <strong>Usos:</strong> {uses}
                                            {maxUsesLabel}
                                        </Typography>
                                        <Typography variant="body2">
                                            <strong>Validez:</strong> {validityFrom} - {validityTo}
                                        </Typography>
                                    </Box>

                                    <Box mt={1} display="flex" justifyContent="flex-end">
                                        <IconButton size="small" color="primary" onClick={() => onEdit(coupon)}>
                                            <EditIcon fontSize="small" />
                                        </IconButton>
                                        <Tooltip
                                            title={
                                                hasAtLeastOneUse(coupon)
                                                    ? 'No se puede eliminar un cupón con usos. Desactívalo desde Editar si no quieres que se siga usando.'
                                                    : 'Eliminar cupón'
                                            }
                                        >
                                            <span>
                                                <IconButton
                                                    size="small"
                                                    color="secondary"
                                                    onClick={() => onDelete(coupon)}
                                                    disabled={hasAtLeastOneUse(coupon)}
                                                >
                                                    <DeleteIcon fontSize="small" />
                                                </IconButton>
                                            </span>
                                        </Tooltip>
                                    </Box>
                                </CardContent>
                            </Card>
                        );
                    })}
            </Box>

            <TablePagination
                component="div"
                count={totalRows}
                page={page}
                onChangePage={onChangePage}
                rowsPerPage={rowsPerPage}
                onChangeRowsPerPage={onChangeRowsPerPage}
                rowsPerPageOptions={[10, 20, 50]}
            />
        </Box>
    );
};

export default CouponsPageMobile;
